import { useTranslation } from 'react-i18next';

import * as St from './DrawingAreaDescriptor.styles';

import AddShapeIcon from '~/icons/add_Shape.svg';
import DrawIcon from '~/icons/draw.svg';
import DrawingAreaText from '~molecules/DrawingAreaText';

const DrawingAreaDescriptor = () => {
  const { t } = useTranslation();

  return (
    <St.Container>
      <St.Descriptor>
        <span>{t('DESIGN_PAGE.DESCRIPTION.MAIN')}</span>
        <DrawingAreaText
          strongText={t('DESIGN_PAGE.DESCRIPTION.PREDEFINED_SHAPE.BOLD')}
          normalText={t('DESIGN_PAGE.DESCRIPTION.PREDEFINED_SHAPE.NORMAL')}
          IconComponent={AddShapeIcon}
        />
        <DrawingAreaText
          strongText={t('DESIGN_PAGE.DESCRIPTION.FREE_DRAW.BOLD')}
          normalText={t('DESIGN_PAGE.DESCRIPTION.FREE_DRAW.NORMAL')}
          IconComponent={DrawIcon}
        />
        <St.Note>{t('DESIGN_PAGE.DESCRIPTION.NOTE')}</St.Note>
      </St.Descriptor>
    </St.Container>
  );
};

export default DrawingAreaDescriptor;
